import { useQuery } from "@tanstack/react-query";
import { fetchIntakeFormForReview } from "@/modules/third-party-risk/requests/intake-form-v2";
import { mapV2QuestionsToIntakeQuestions } from "../utils/map-v2-to-intake-question";

export function useBusinessOwnerFormQuery(formId: string | undefined) {
  return useQuery({
    queryKey: ["business-owner-form", formId],
    queryFn: async () => {
      const data = await fetchIntakeFormForReview(formId!);
      return {
        businessOwnerForm: data.business_owner_form,
        questions: mapV2QuestionsToIntakeQuestions(data.questions),
      };
    },
    enabled: !!formId,
    retry: 3,
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 10000),
  });
}
